import { WIDGET_COOKIE_NAME, type WidgetCacheEntry } from '@/config';
import { readWidgetCache } from './getWidgetCookie';

export default function setWidgetCookie(ref: string, entry: WidgetCacheEntry) {
  const cache = { ...readWidgetCache(), [ref]: entry };
  const value = encodeURIComponent(JSON.stringify(cache));

  document.cookie = `${WIDGET_COOKIE_NAME}=${value}; path=/; SameSite=Lax`;
}
